
export const brandsData = [
    {
        title : 'apple',
        img : 'images/apple.png'
    },
    {
        title : 'microsoft',
        img : 'images/microsoft.png'
    },
    {
        title : 'dell',
        img : 'images/dell.png'
    },
    {
        title : 'hp',
        img : 'images/hp.png'
    },
    {
        title : 'samsung',
        img : 'images/samsung.png'
    },
    {
        title : 'sony',
        img : 'images/sony.png'
    },
    {
        title : 'lenovo',
        img : 'images/lenovo.png'
    },
    {
        title : 'huawei',
        img : 'images/huawei.png'
    },
]


export const appleHero = 
    {
        background: '../../../../images/apple-hero.png',
        logo: '../../../../images/apple.png'
    }

export const microsoftHero = 
    {
        background: '../../../../images/microsoft-hero.png',
        logo: '../../../../images/microsoft.png'
    }

export const dellHero = 
    {
        background: '../../../../images/dell-hero-1.jpg',
        logo: '../../../../images/dell.png'
    }

export const hpHero = 
    {
        background: '../../../../images/hp-hero.jpg',
        logo: '../../../../images/hp.png'
    }

export const samsungHero = 
    {
        background: '../../../../images/samsung-hero.jpg',
        logo: '../../../../images/samsung.png'
    }

export const sonyHero = 
    {
        background: '../../../../images/sony-hero.jpg',
        logo: '../../../../images/sony.png'
    }

export const lenovoHero = 
    {
        background: '../../../../images/lenovo-hero.jpg',
        logo: '../../../../images/lenovo.png'
    }

export const huaweiHero = 
    {
        background: '../../../../images/hp-hero.jpg',
        logo: '../../../../images/huawei.png'
    }




export const appleShowcase = [
        {
            url: '../../../../images/apple-4.png'
        },
        {
            url: '../../../../images/apple-3.jpg'
        },
        {
            url: '../../../../images/apple-9.png'
        },
        {
            url: '../../../../images/apple-2.jpg'
        },
        {
            url: '../../../../images/apple-13.png'
        },
        {
            url: '../../../../images/apple-5.jpg'
        },
        {
            url: '../../../../images/apple-6.jpg'
        },
        {
            url: '../../../../images/apple-7.jpg'
        },
        {
            url: '../../../../images/apple-12.jpeg'
        },
    ]

export const micorsoftShowcase = [
        {
            url: '../../../../images/microsoft-2.jpg'
        },
        {
            url: '../../../../images/microsoft-3.jpg'
        },
        {
            url: '../../../../images/microsoft-1.jpg'
        },
        {
            url: '../../../../images/microsoft-10.png'
        },
        {
            url: '../../../../images/microsoft-11.png'
        },
        {
            url: '../../../../images/microsoft-12.png'
        },
        {
            url: '../../../../images/microsoft-4.jpg'
        },
        {
            url: '../../../../images/microsoft-9.jpg'
        },
        {
            url: '../../../../images/microsoft-7.jpg'
        },
    ]
export const dellShowcase = [
        {
            url: '../../../../images/dell-1.jpg'
        },
        {
            url: '../../../../images/dell-7.png'
        },
        {
            url: '../../../../images/dell-3.jpg'
        },
        {
            url: '../../../../images/dell-12.jpg'
        },
        {
            url: '../../../../images/dell-15.jpg'
        },
        {
            url: '../../../../images/dell-9.jpg'
        },
        {
            url: '../../../../images/dell-7.png'
        },
        {
            url: '../../../../images/dell-5.jpg'
        },
        {
            url: '../../../../images/dell-1.jpg'
        },
    ]
export const hpShowcase = [
        {
            url: '../../../../images/hp-8.jpg'
        },
        {
            url: '../../../../images/hp-2.jpg'
        },
        {
            url: '../../../../images/hp-1.jpg'
        },
        {
            url: '../../../../images/hp-5.jpg'
        },
        {
            url: '../../../../images/hp-8.jpg'
        },
        {
            url: '../../../../images/dell-12.jpg'
        },
        {
            url: '../../../../images/hp-9.jpg'
        },
        {
            url: '../../../../images/hp-10.jpg'
        },
        {
            url: '../../../../images/dell-13.webp'
        },
    ]
export const samsungShowcase = [
        {
            url: '../../../../images/samsung-1.jpg'
        },
        {
            url: '../../../../images/samsung-8.jpg'
        },
        {
            url: '../../../../images/samsung-2.jpg'
        },
        {
            url: '../../../../images/samsung-4.jpg'
        },
        {
            url: '../../../../images/samsung-5.jpg'
        },
        {
            url: '../../../../images/samsung-6.jpg'
        },
        {
            url: '../../../../images/samsung-9.jpg'
        },
        {
            url: '../../../../images/samsung-7.jpg'
        },
        {
            url: '../../../../images/samsung-10.webp'
        },
    ]
export const sonyShowcase = [
        {
            url: '../../../../images/sony-7.jpg'
        },
        {
            url: '../../../../images/sony-8.jpg'
        },
        {
            url: '../../../../images/sony-11.jpg'
        },
        {
            url: '../../../../images/sony-9.jpg'
        },
        {
            url: '../../../../images/sony-4.jpg'
        },
        {
            url: '../../../../images/sony-10.jpg'
        },
        {
            url: '../../../../images/sony-2.jpg'
        },
        {
            url: '../../../../images/sony-17.jpg'
        },
        {
            url: '../../../../images/sony-17.webp'
        },
    ]
export const lenovoShowcase = [
        {
            url: '../../../../images/lenovo-1.webp'
        },
        {
            url: '../../../../images/lenovo-3.jpg'
        },
        {
            url: '../../../../images/lenovo-2.jpg'
        },
        {
            url: '../../../../images/lenovo-4.jpg'
        },
        {
            url: '../../../../images/lenovo-13.webp'
        },
        {
            url: '../../../../images/lenovo-14.jpg'
        },
        {
            url: '../../../../images/lenovo-8.jpg'
        },
        {
            url: '../../../../images/lenovo-11.jpg'
        },
        {
            url: '../../../../images/lenovo-4.jpg'
        },
    ]
export const huaweiShowcase = [
        {
            url: '../../../../images/huawei-1.jpg'
        },
        {
            url: '../../../../images/huawei-3.jpg'
        },
        {
            url: '../../../../images/huawei-5.jpg'
        },
        {
            url: '../../../../images/huawei-13.webp'
        },
        {
            url: '../../../../images/huawei-12.jpg'
        },
        {
            url: '../../../../images/huawei-9.jpg'
        },
        {
            url: '../../../../images/huawei-11.jpg'
        },
        {
            url: '../../../../images/huawei-8.jpeg'
        },
        {
            url: '../../../../images/huawei-10.jpg'
        },
    ]